export type BiReportItem = {
    section: string;
    claim: string;
    name: string;
    rxmodels: string[];
};

export type BiMenuItem = {
    title: string;
    reports: BiReportItem[];
};

// Tableau Embedding API v3 (3.10) - `<tableau-viz>` custom element, replaces the old window.tableau.Viz object
// https://help.tableau.com/current/api/embedding_api/en-us/
export interface TableauViz extends HTMLElement {
    src: string;
    toolbar: string;
    hideTabs: boolean;
    width: string;
    height: string;
    displayDialogAsync(dialogType: TableauDialogType): Promise<void>;
}

export enum TableauDialogType {
    ExportPDF = 'export-pdf',
    ExportCrossTab = 'export-cross-tab',
}
